export var filteredStringList = function (values) { return values.filter(function (e) { return e; }).join(' '); };
//# sourceMappingURL=filtered-string-list.js.map